import { useRouteChangeEvent } from "@circle-react/hooks/utils/useRouteChangeEvent";

export const RouteChangeEventWrapper = ({ children }) => {
  useRouteChangeEvent();
  return children;
};
